import React from 'react';

class EmailQuestion extends React.Component {
  constructor(props){
    super(props);
    const {errors, isError} = props;
    this.state = {errors, isError};
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(e){
    let {value} = e.target;
    const {field} = this.props;
    //Cambiar estados
    this.props.handleChangeListener(field, value, null, null, null);
  }

  render() {
    const {field,text,note,predefinedValue, placeHolder} = this.props;
    const {errors, isError} = this.props;
    const errorList = errors !== null? errors.map( (error) =>  <li key={error}>{error}</li>) : null

    return (
      <div className="pregunta">
          <div className="form-group">
              <label htmlFor={field}>{text}</label>
              <input 
                name={field} 
                type="email" 
                className="form-control"
                defaultValue={predefinedValue}
                placeholder={placeHolder}
                onChange={this.onChangeHandler}
                />
              <p className="question-subinstruction">{note}</p>
              {isError === true ? 
                <ul className="error">
                  {errorList}
                </ul>
                : null
              }        
          </div>
      </div>
    );
  }
}

export default EmailQuestion;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/EmailQuestion.js